import { render, staticRenderFns } from "./ProfitAndLoss.vue?vue&type=template&id=a76f580a&scoped=true&"
import script from "./ProfitAndLoss.vue?vue&type=script&lang=js&"
export * from "./ProfitAndLoss.vue?vue&type=script&lang=js&"
import style0 from "./ProfitAndLoss.vue?vue&type=style&index=0&id=a76f580a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76f580a",
  null
  
)

export default component.exports